import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { CloseIcon } from 'components/global/icons'

export const CloseButton = ({ onClick }) => (
  <span
    className="pointer"
    data-dismiss="modal"
    aria-label="Close"
    onClick={onClick}
    data-testid="close-btn"
  >
    <CloseIcon />
  </span>
)

CloseButton.propTypes = {
  onClick: PropTypes.func,
}

class Modal extends Component {
  constructor(props) {
    super(props)
    let animation = 'fadeInDown'

    if (props.classPostion) {
      const LOCALE = localStorage.getItem('Locale') || 'en'
      animation = LOCALE === 'en' ? 'fadeInRight' : 'fadeInLeft'
    }

    this.state = {
      animation,
      containerAnimation: 'fadeIn',
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  setWrapRef = (c) => {
    this.wrapRef = c
  }

  handleClickedOut = (event) => {
    if (this.wrapRef === event.target) this.handleClose()
  }

  timer = null
  handleClose = () => {
    const { onCloseModal, classPostion } = this.props
    let animation = 'fadeOutUp'

    if (classPostion) {
      const LOCALE = localStorage.getItem('Locale') || 'en'
      animation = LOCALE === 'en' ? 'fadeOutRight' : 'fadeOutLeft'
    }

    if (onCloseModal) {
      this.setState({ animation, containerAnimation: 'fadeOut' })
      this.timer = setTimeout(() => this.props.onCloseModal(), 1000)
    }
  }

  render() {
    const {
      actions,
      children,
      classPostion,
      className,
      title,
      fetching,
      hideCloseButton,
      contentStyle,
    } = this.props
    const { animation, containerAnimation } = this.state

    const lodaerOrChildren = fetching ? <i className="loader azure-color loader-40" /> : children

    return ReactDOM.createPortal(
      <div
        className={classNames(
          'modal show modal-template animated jisr-modal',
          containerAnimation,
          classPostion,
          className,
        )}
        tabIndex={-1}
        ref={this.setWrapRef}
        onClick={this.handleClickedOut}
        role="dialog"
      >
        <div
          className={classNames('modal-dialog animated', animation)}
          role="document"
        >
          <div
            className="modal-content"
            style={contentStyle}
          >
            {(title || actions) && (
              <div className="modal-header flex space-between">
                {title && <h5 className="modal-title">{title}</h5>}
                {actions}
                {!hideCloseButton && <CloseButton onClick={this.handleClose} />}
              </div>
            )}
            <div className="modal-body">{lodaerOrChildren}</div>
          </div>
        </div>
      </div>,
      document.getElementById('modal'),
    )
  }
}

Modal.propTypes = {
  actions: PropTypes.node,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.node,
  ]),
  classPostion: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.shape(), PropTypes.string]),
  fetching: PropTypes.bool,
  hideCloseButton: PropTypes.bool,
  onCloseModal: PropTypes.func.isRequired,
  contentStyle: PropTypes.shape(),
}

const ModalTemplate = (props) => (props.isOpen ? <Modal {...props} /> : null)

ModalTemplate.propTypes = {
  isOpen: PropTypes.bool.isRequired,
}

export default ModalTemplate
